import { render, staticRenderFns } from "./AvailableEvents.vue?vue&type=template&id=44c81f8a&scoped=true&"
import script from "./AvailableEvents.vue?vue&type=script&lang=js&"
export * from "./AvailableEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c81f8a",
  null
  
)

export default component.exports